import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  box-shadow: ${(props) => props.theme['shadow.card']};
  border-radius: 4px;
  background-color: ${(props) => props.theme['color.surface']};
  color: ${(props) => props.theme['color.text.body']};
`;

export {
  Card,
};
